<div class="gw-clearfix" />

<style>
    .gw-clearfix {
        display: block;
        zoom: 1;
    }

    .gw-clearfix:after,
    .gw-clearfix:before {
        content: "";
        display: table;
    }

    .gw-clearfix:after {
        clear: both;
    }
</style>
